<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r15">IP 검색대역</div>
      <div class="setting-addel">
        <el-button @click="clickAddIpSearchButton"><i class="fas fa-plus" /></el-button>
        <el-button @click="clickDeleteIpSearchButton" :disabled="checkedRows == 0"><i class="fas fa-minus" /></el-button>
      </div>
    </div>
    <div class="vertical-center-box">
      <el-button class="mr-r4" size="mini" type="content" @click="importIpSearchExcel">
        <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
        <span style="left:2px;bottom:5px;">  엑셀입력</span>
      </el-button>
      <el-button class="mr-r4" size="mini" type="content" @click="exportIpSearchExcel">
        <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
        <span style="left:2px;bottom:5px;">  엑셀출력</span>
      </el-button>
      <w-header-search-button class="mr-r4" size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      <el-button type="primary" @click="clickNextStep" :disabled="checkedRows == 0 || !isLoaded">다음단계</el-button>
    </div>
  </el-row>
  <el-table-wrapper :data="ipSearchTableData" :columns="ipSearchTableColumn" :column-default="columnDefault" ref="ipSearchTable" row-class-name="c-dblclick" :show-search-tool="showSearchTool" highlight-current-row pagination
    :show-custom-header="true" @select="onSelect" @select-all="onSelectAll" @row-dblclick="dblclickRow" style="width:100%;" :total="total" remote @condition-change="onChangeTable">
  </el-table-wrapper>
  <w-add-ip-search-popup ref="addIpSearchPopup" @re-load="loadData" :popup-type="popupType" :selected-ip-search-row="selectedIpSearchRow"></w-add-ip-search-popup>
  <w-import-excel-ip-search-popup ref="importExcelSyncSlidingPopup" @reload-data="loadData" />
</div>
</template>

<script>
import { cloneDeep, isNil, isEqual, filter } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import WAddIpSearchPopup from '../popup/AddIpSearchPopup';
import WImportExcelIpSearchPopup from '../popup/ImportExcelIpSearchPopup';

export default {
  name: 'WIpSearchSetting',
  components: {
    WAddIpSearchPopup,
    WImportExcelIpSearchPopup,
  },
  props: {
    checkedIpSearchRows: Array,
  },
  data() {
    return {
      isLoaded: false,
      showSearchTool: false,
      total: 0,
      checkedRows: [],
      popupType: 'ADD',
      selectedIpSearchRow: null,
      ipSearchTableData: [],
      columnDefault,
      ipSearchTableColumn: [
        {
          type: 'selection',
        },
        {
          prop: 'scanId',
          label: '검색방법 ID',
          headerAlign: 'center',
          sortable: true,
          sortProp: 'na.scan_id',
        },
        {
          prop: 'scanType',
          label: 'IP 검색방법',
          headerAlign: 'center',
          sortable: true,
          sortProp: 'na.scan_type',
          formatter: this.scanTypeFormatter,
        },
        {
          prop: 'startAddress',
          label: '시작IP',
          remoteProp: 'na.start_address',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'endAddress',
          label: '종료IP',
          remoteProp: 'na.end_address',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
        },
        {
          label: '예외구간',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'exceptStartAddress',
              label: '예외시작IP',
              headerAlign: 'center',
              sortable: true,
              sortProp: 'na.except_start_address',
            },
            {
              prop: 'exceptEndAddress',
              label: '예외종료IP',
              headerAlign: 'center',
              sortable: true,
              sortProp: 'na.except_end_address',
            },
          ],
        },
        {
          prop: 'agentManagerGroupName',
          label: '수집AM선택',
          headerAlign: 'center',
          sortable: true,
          sortProp: 'amg.agent_manager_group_name',
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.ipSearchTable.getParameter();
      const params = {
        ...tableParams,
      };
      this.isLoaded = false;
      DeviceRegistrationNmsAPI.getNmsAutodiscoveryList(params).then((response) => {
        this.ipSearchTableData = response.data.data;
        this.total = response.data.total;
        this.isLoaded = true;
        this.onCheckedSelection();
      });
    },
    clickAddIpSearchButton() {
      this.popupType = 'ADD';
      this.$refs.addIpSearchPopup.$refs.slidingPopup.visible = true;
    },
    clickDeleteIpSearchButton() {
      const target = 'IP 검색 대역';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        DeviceRegistrationNmsAPI.deleteNmsAutodiscoveryList(this.checkedRows)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
      this.$refs.ipSearchTable.clearFilter();
    },
    dblclickRow(row) {
      this.popupType = 'UPDATE';
      const tempRow = cloneDeep(row);
      const ipaddressApplytype = isEqual(tempRow.checkIpv6Flag, '1') ? 'IPv6' : 'IPv4';
      tempRow.ipaddressApplytype = ipaddressApplytype;
      tempRow.checkExceptFlag = true;
      if (isEqual(ipaddressApplytype, 'IPv6')) {
        tempRow.ip6StartAddress = tempRow.startAddress;
      } else {
        const scanType = tempRow.scanType;
        if (isEqual(scanType, 'SPOT')) {
          tempRow.spotStartAddress = tempRow.startAddress;
        } else if (isEqual(scanType, 'RANGE')) {
          tempRow.rangeStartAddress = tempRow.startAddress;
          tempRow.rangeEndAddress = tempRow.endAddress;
        } else {
          tempRow.seedStartAddress = tempRow.startAddress;
          tempRow.seedEndAddress = tempRow.endAddress;
        }
      }
      this.selectedIpSearchRow = tempRow;
      this.$refs.addIpSearchPopup.$refs.slidingPopup.visible = true;
    },
    /**
     * 체크박스 선택/해제시 배열 checkedRows에 반영
     * @author NaJY
     * @param  {[Object]} row       [description]
     * @param  {[Array]}  selection [description]
     */
    onSelect(selection, row) {
      const checkedScanId = this.checkedRows.find((data) => (data.scanId === row.scanId));
      if (!isNil(checkedScanId)) {
        this.checkedRows.splice(this.checkedRows.indexOf(checkedScanId), 1);
      } else {
        this.checkedRows.push(row);
      }
    },
    /**
     * 체크박스 전체선택/해제시 배열 checkedRows에 반영
     * @author NaJY
     * @param  {[Array]}  selection [description]
     */
    onSelectAll(selection) {
      this.ipSearchTableData.forEach((row) => {
        const checkedScanId = this.checkedRows.find((data) => (data.scanId === row.scanId));
        if (selection.length > 0) {
          if (isNil(checkedScanId)) {
            this.checkedRows.push(row);
          }
        } else if (selection <= 0) {
          if (!isNil(checkedScanId)) {
            this.checkedRows.splice(this.checkedRows.indexOf(checkedScanId), 1);
          }
        }
      });
    },
    clickNextStep() {
      const checkedRows = this.checkedRows;
      if (this.checkedIpSearchRows.length > 0) {
        const checkedIpSearchRows = this.checkedIpSearchRows;
        checkedRows.forEach((object) => {
          checkedIpSearchRows.forEach((tempObject) => {
            if (isEqual(object.scanId, tempObject.scanId)) {
              Object.assign(object, tempObject);
            }
          });
        });
      }
      this.$emit('click-next-step', checkedRows, 'checkedIpSearchRows');
    },
    exportIpSearchExcel() {
      DeviceRegistrationNmsAPI.exportIpSearchList();
    },
    importIpSearchExcel() {
      // 템플릿은 엑셀 출력 시 생성한 파일
      this.$refs.importExcelSyncSlidingPopup.open();
    },
    scanTypeFormatter(row, column, value) {
      let result = null;
      if (!isNil(value)) {
        if (isEqual(value, 'SPOT')) {
          result = '단일 IP';
        } else if (isEqual(value, 'RANGE')) {
          result = 'IP 구간';
        } else {
          result = '서브넷마스크';
        }
      }
      return result;
    },
    onChangeTable() {
      this.loadData();
    },
    /**
     * 배열 checkedRows에 있는 데이터라면 체크박스 체크된채로 유지
     * @author NaJY
     */
    onCheckedSelection() {
      if (!isNil(this.ipSearchTableData)) {
        this.ipSearchTableData.forEach((row) => {
          const checkedSingleRow = this.checkedRows.find((singleRow) => singleRow.scanId === row.scanId);
          row.checked = !isNil(checkedSingleRow) ? 1 : 0;
        });
        const checkedRowData = filter(this.ipSearchTableData, (item) => item.checked === 1);
        this.$nextTick(() => {
          this.$refs.ipSearchTable.getTable().clearSelection();
          checkedRowData.forEach((row) => {
            this.$refs.ipSearchTable.getTable().toggleRowSelection(row);
          });
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/components/IpSearchSetting.vue